import ImageWrapper from "./ImageWrapper";
import ImageInformation from "./ImageInformation";

export default [
  {
    path: "/images/:id",
    component: ImageWrapper,
    children: [
      {
        path: "",
        name: "image_info",
        component: ImageInformation,
        meta: {
          toolbar: "image",
          tabAccess: "DATABASE",
        },
      },
    ],
  },
];
